require('./RAFaq.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const RACover = require('../commons/RACover/RACover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @constants
const { BROKER_PG_URL } = require('constants/index');
const {
    MYPROFILE_BROKER_ROBO_URL,
    PROC_RA_FAQS,
    PROC_RA_FAQS_INTERACTION,
    PROC_RA_GO_BACK,
} = require('../../raConstants/index');

class RAFaqView extends React.Component {
    constructor(props) {
        super(props);
        this.handleGoToLandingPageOfRobo = this.handleGoToLandingPageOfRobo.bind(
            this,
        );
        this.handleAccordionQuestionClick = this.handleAccordionQuestionClick.bind(
            this,
        );
    }

    handleAccordionQuestionClick(isExpanded, id) {
        recordLink(PROC_RA_FAQS, id, PROC_RA_FAQS_INTERACTION);
    }

    handleGoToLandingPageOfRobo() {
        recordLink(PROC_RA_FAQS, PROC_RA_GO_BACK, PROC_RA_FAQS_INTERACTION);
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    getSectionDetails() {
        return [
            {
                text: (
                    <FormattedText value="raFaq-automatedInvestmentSectionTitle" />
                ),
                name: 'automatedInvestment',
                details: [
                    {
                        id: 'autoInv1',
                        questionText: (
                            <FormattedText value="raFaq-autoInvQuestion1" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-autoInvAnswer1" />
                        ),
                    },
                    {
                        id: 'autoInv2',
                        questionText: (
                            <FormattedText value="raFaq-autoInvQuestion2" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-autoInvAnswer2" />
                        ),
                    },
                    {
                        id: 'autoInv3',
                        questionText: (
                            <FormattedText value="raFaq-autoInvQuestion3" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-autoInvAnswer3" />
                        ),
                    },
                    {
                        id: 'autoInv4',
                        questionText: (
                            <FormattedText value="raFaq-autoInvQuestion4" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-autoInvAnswer4" />
                        ),
                    },
                ],
            },
            {
                text: (
                    <FormattedText value="raFaq-objectiveInvestmentSectionTitle" />
                ),
                name: 'objInvestment',
                details: [
                    {
                        id: 'objInv1',
                        questionText: (
                            <FormattedText value="raFaq-objInvQuestion1" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-objInvAnswer1" />
                        ),
                    },
                    {
                        id: 'objInv2',
                        questionText: (
                            <FormattedText value="raFaq-objInvQuestion2" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-objInvAnswer2" />
                        ),
                    },
                    {
                        id: 'objInv3',
                        questionText: (
                            <FormattedText value="raFaq-objInvQuestion3" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-objInvAnswer3" />
                        ),
                    },
                    {
                        id: 'objInv4',
                        questionText: (
                            <FormattedText value="raFaq-objInvQuestion4" />
                        ),
                        answerText: (
                            <FormattedText value="raFaq-objInvAnswer4" />
                        ),
                    },
                ],
            },
        ];
    }

    buildSectionTitle(title) {
        return <div className="ra-faq__section-title">{title}</div>;
    }

    buildAccordionSection(accordionSectionContent) {
        const sectionName = accordionSectionContent;
        let accordionContent;

        accordionContent = sectionName.map((dataSet, index) => {
            const id = dataSet.id;
            const headerText = dataSet.questionText;
            const bodyText = dataSet.answerText;

            return (
                <Accordion
                    customClassName="ra-faq__accordion"
                    id={id}
                    key={index}
                    onClick={this.handleAccordionQuestionClick}
                >
                    <AccordionHeader name="AccordionHeader">
                        <div className="ra-faq__accordion-header">
                            {headerText}
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div className="ra-faq__accordion-container">
                            {bodyText}
                        </div>
                    </AccordionBody>
                </Accordion>
            );
        });

        return accordionContent;
    }

    buildFaqSections() {
        const faqSectionDetails = this.getSectionDetails();
        let content;
        content = faqSectionDetails.map((content, index) => {
            const sectionTitle = this.buildSectionTitle(content.text);
            const accordionContent = this.buildAccordionSection(
                content.details,
            );

            return (
                <div key={content.name + index}>
                    {sectionTitle}
                    {accordionContent}
                </div>
            );
        });

        return content;
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('raFaq-investments'),
                url: BROKER_PG_URL,
            },
            {
                text: formatText('raFaq-managementPlanBreadcrumb'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('raFaq-moreDetails'),
            },
        ];
    }

    render() {
        const mappingBreadcrumb = this.getBreadcrumb();
        const rightContent = (
            <OKButton
                modifier="ghost"
                inverse={true}
                className="ra-robo-more-options-button__back-button"
                onClick={this.handleGoToLandingPageOfRobo}
                leftIcon="icon-anterior"
            >
                <FormattedText value="raRoboMoreOptionsButton-backButton" />
            </OKButton>
        );
        const content = this.buildFaqSections();

        return (
            <div className="ra-faq grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            showHelp={false}
                            title={formatText('raFaq-moreDetails')}
                            rightContent={rightContent}
                            overlap={false}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="grid-view__body">
                        <div className="container-fluid">{content}</div>
                    </div>
                </div>
            </div>
        );
    }
}

RAFaqView.propTypes = {
    history: PropTypes.object.isRequired,
    immFaq: PropTypes.object.isRequired,
    faqAccordionToggle: PropTypes.func.isRequired,
};

module.exports = withRouter(RAFaqView);
